import { SignIn, SignedIn } from "@clerk/clerk-react";
import { Navigate } from "react-router-dom";

export function LoginPage() {
  return (
    <>
      <SignedIn>
        <Navigate to="/admin" replace />
      </SignedIn>
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 px-4">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-white">Apptonomy Admin</h1>
            <p className="mt-2 text-gray-400">Sign in to access the admin dashboard</p>
          </div>
          <div className="flex justify-center">
            <SignIn
              routing="path"
              path="/admin/login"
              forceRedirectUrl="/admin"
            />
          </div>
        </div>
      </div>
    </>
  );
}
